<template>
  <div class="device">
    <div class="nav-box">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
        <el-tab-pane
          v-for="(item, index) in list"
          :key="index"
          :label="item.categoryName"
          :name="item.categoryId"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <div class="device-content">
      <DeviceForm :deviceId="deviceId"></DeviceForm>
      <!-- <router-view /> -->
    </div>
  </div>
</template>

<script>
import DeviceForm from "@/components/deviceForm/index.vue";
export default {
  name: "Page",
  components: { DeviceForm },
  data() {
    return {
      list: [],
      deviceId: "",
      activeName: "",
    };
  },
  methods: {
    handleClick(name) {
      this.deviceId = name;
    },
    async init() {
      try {
        let res;
        res = await this.$myRequest({
          url: "/list-device-setting-tab-list",
          method: "get",
          data: {},
        });
        // debugger;
        this.list = res.data.data;

        this.deviceId = this.list[0].categoryId;
        this.activeName = this.list[0].categoryId;

        // if (this.$route.matched[3]) {
        //   this.$router.push({ name: this.$route.matched[3].name });
        // } else {
        //   this.$router.push({
        //     name: "adminSetDevice" + this.list[0].categoryId,
        //   });
        // }
      } catch (err) {
        console.log("err tablist");
        console.log(err);
      }
    },
  },
  mounted() {
    this.init();
        this.$store.commit("checkTick");
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
